import { TagEventsEnum } from 'common/enums/TagEventsEnum'
import BaseBridge from 'config/bridge/BaseBridge'

export const analyticsMyTicketsTab = (params?: Record<string, string>) => {
  BaseBridge.requestAnalytics(TagEventsEnum.CAPITALIZACAO_FLUXO, {
    screen_name: 'Sortezinha:MinhasSortezinhas',
    product_area: 'Pós-venda',
    section: 'Minhas Sortezinhas',
    product: 'capitalização',
    step: '1',
    flow: 'prateleira',
    ...params,
  })
}
